import {
  IsNotEmpty,
  IsDateString,
  IsBoolean,
  IsString,
  IsNumber,
  IsOptional,
  Min,
} from 'class-validator';

const notEmptyOptions = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class CreateVacationFillingDto {
  @IsNumber()
  @Min(1)
  @IsOptional()
  minDurationDays: number;

  @IsString()
  @IsOptional()
  minDurationUnit: string;

  @IsBoolean()
  @IsOptional()
  weekendExclusion: boolean;

  @IsBoolean()
  @IsOptional()
  minDuration: boolean;

  @IsNumber()
  @Min(1)
  @IsOptional()
  maxDurationDays: number;

  @IsString()
  @IsOptional()
  maxDurationUnit: string;

  @IsBoolean()
  @IsOptional()
  maxDuration: boolean;

  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  employeeDeadline: string;

  @IsBoolean()
  @IsOptional()
  mustScheduleAllDays: boolean;

  @IsBoolean()
  @IsOptional()
  mustSchedule14days: boolean;

  @IsBoolean()
  @IsOptional()
  daysMustBeDivisibleBy: boolean;

  @IsString()
  @IsNotEmpty(notEmptyOptions)
  employeeCanSeeVacations: string;

  @IsString()
  @IsNotEmpty(notEmptyOptions)
  allowEmployeeComment: string;

  @IsNumber()
  // eslint-disable-next-line no-magic-numbers
  @Min(2)
  @IsOptional()
  daysMustBeDivisibleByNumber: number;

  @IsBoolean()
  @IsOptional()
  limitToCalculatedDays: boolean;

  @IsString()
  @IsOptional()
  companyComment: string;
}
